import React from 'react'
import events from'../Assets/Images/events.jpg'
import { SlideshowLightbox } from 'lightbox.js-react'
import { Link } from 'react-router-dom'
const Events = () => {
  return (
     <>
     <div className="innerslide">
     <ul className="breadcrumb">
            <li><Link to="/"> Home</Link> </li>
            <li> Events </li>
            </ul>
    </div>
        <div className="innersec">
        <div className="container">
        <div className="row">
            <div className="col-lg-12">
                <h1> Events </h1>
            </div>
        </div> 
        <div className="row tabs-dynamic">
                <div className="col-md-3">
                    <div className="count-val">
                        <p>Total Count: </p>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="month-selection">
                        <select className="yearSelection">
                            <option className="2024" selected>2024</option>
                            <option className="2023">2023</option>
                        </select>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="month-selection">
                        <select className="monthSelect">
                            <option value="0">All Month</option>
                            <option value="1">Jan</option>
                            <option value="2">Feb</option>
                            <option value="3">Mar</option>
                            <option value="4">Apr</option>
                            <option value="5">May</option>
                            <option value="6">Jun</option>
                            <option value="7">Jul</option>
                            <option value="8">Aug</option>
                            <option value="9">Sep</option>
                            <option value="10">Oct</option>
                            <option value="11">Nov</option>
                            <option value="12">Dec</option>
                        </select>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="searchBox">
                        <input type="text" id="myInput" name="name" autocomplete="off" placeholder="Search Here.." />
                    </div>
                </div>
            </div>
            <div className="row years year2024 showYear">


                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 eventCount " data-month="1">
                    <div className="eventbox">
                        <div className="eventboximg">
                        <div className="eventattch"><Link to=" " target="_blank"><i className="bi bi-paperclip"></i></Link></div> 
                         <SlideshowLightbox><img src={events} className="img-fluid border-img w-full rounded" alt="Sacred Heart Convent School, Jagraon" /></SlideshowLightbox>
                        </div><div className="eventboxdesc">
                            <div className="eventpgh">
                            <h5>Events Title</h5>
                            <p>Stay Tunned For More Updates Stay Tunned For More Updates Stay Tunned For More Updates</p>
                            </div>
                            <div className="eventdate">
                            <span><i className="bi bi-alarm"></i> 00:00</span>
                            <span><i className="bi bi-calendar"></i> 28.02.2024</span>
                            <span><i className="bi bi-geo-alt"></i> School campus</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 eventCount " data-month="1">
                    <div className="eventbox">
                        <div className="eventboximg">
                        <div className="eventattch"><Link to=" " target="_blank"><i className="bi bi-paperclip"></i></Link></div> 
                         <SlideshowLightbox><img src={events} className="img-fluid border-img w-full rounded" alt="Sacred Heart Convent School, Jagraon" /></SlideshowLightbox>
                        </div><div className="eventboxdesc">
                            <div className="eventpgh">
                            <h5>Events Title</h5>
                            <p>Stay Tunned For More Updates Stay Tunned For More Updates Stay Tunned For More Updates</p>
                            </div>
                            <div className="eventdate">
                            <span><i className="bi bi-alarm"></i> 00:00</span>
                            <span><i className="bi bi-calendar"></i> 28.02.2024</span>
                            <span><i className="bi bi-geo-alt"></i> School campus</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 eventCount " data-month="2">
        <div className="eventbox">
                        <div className="eventboximg">
                        <div className="eventattch"><Link to=" " target="_blank"><i className="bi bi-paperclip"></i></Link></div> 
                         <SlideshowLightbox><img src={events} className="img-fluid border-img w-full rounded" alt="Sacred Heart Convent School, Jagraon" /></SlideshowLightbox>
                        </div><div className="eventboxdesc">
                            <div className="eventpgh">
                            <h5>Events Title</h5>
                            <p>Stay Tunned For More Updates Stay Tunned For More Updates Stay Tunned For More Updates</p>
                            </div>
                            <div className="eventdate">
                            <span><i className="bi bi-alarm"></i> 00:00</span>
                            <span><i className="bi bi-calendar"></i> 28.02.2024</span>
                            <span><i className="bi bi-geo-alt"></i> School campus</span>
                            </div>
                        </div>
                    </div>
        </div>

                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 eventCount " data-month="2">
                    <div className="eventbox">
                        <div className="eventboximg">
                        <div className="eventattch"><Link to=" " target="_blank"><i className="bi bi-paperclip"></i></Link></div> 
                         <SlideshowLightbox><img src={events} className="img-fluid border-img w-full rounded" alt="Sacred Heart Convent School, Jagraon" /></SlideshowLightbox>
                        </div><div className="eventboxdesc">
                            <div className="eventpgh">
                            <h5>Events Title</h5>
                            <p>Stay Tunned For More Updates Stay Tunned For More Updates Stay Tunned For More Updates</p>
                            </div>
                            <div className="eventdate">
                            <span><i className="bi bi-alarm"></i> 00:00</span>
                            <span><i className="bi bi-calendar"></i> 28.02.2024</span>
                            <span><i className="bi bi-geo-alt"></i> School campus</span>
                            </div>
                        </div>
                    </div>
                </div>
                            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 eventCount " data-month="2">
                    <div className="eventbox">
                        <div className="eventboximg">
                        <div className="eventattch"><Link to=" " target="_blank"><i className="bi bi-paperclip"></i></Link></div> 
                         <SlideshowLightbox><img src={events} className="img-fluid border-img w-full rounded" alt="Sacred Heart Convent School, Jagraon" /></SlideshowLightbox>
                        </div><div className="eventboxdesc">
                            <div className="eventpgh">
                            <h5>Events Title</h5>
                            <p>Stay Tunned For More Updates Stay Tunned For More Updates Stay Tunned For More Updates</p>
                            </div>
                            <div className="eventdate">
                            <span><i className="bi bi-alarm"></i> 00:00</span>
                            <span><i className="bi bi-calendar"></i> 28.02.2024</span>
                            <span><i className="bi bi-geo-alt"></i> School campus</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 eventCount " data-month="2">

            <div className="eventbox">
                        <div className="eventboximg">
                        <div className="eventattch"><Link to=" " target="_blank"><i className="bi bi-paperclip"></i></Link></div> 
                         <SlideshowLightbox><img src={events} className="img-fluid border-img w-full rounded" alt="Sacred Heart Convent School, Jagraon" /></SlideshowLightbox>
                        </div><div className="eventboxdesc">
                            <div className="eventpgh">
                            <h5>Events Title</h5>
                            <p>Stay Tunned For More Updates Stay Tunned For More Updates Stay Tunned For More Updates</p>
                            </div>
                            <div className="eventdate">
                            <span><i className="bi bi-alarm"></i> 00:00</span>
                            <span><i className="bi bi-calendar"></i> 28.02.2024</span>
                            <span><i className="bi bi-geo-alt"></i> School campus</span>
                            </div>
                        </div>
                    </div>
        </div>
                <div className="load-more">
                    <div className="next">Show More</div>
                </div>
            </div>
            <div className="row years year2023">


                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 eventCount " data-month="1">
                    <div className="eventbox">
                        <div className="eventboximg">
                        <div className="eventattch"><Link to=" " target="_blank"><i className="bi bi-paperclip"></i></Link></div> 
                         <SlideshowLightbox><img src={events} className="img-fluid border-img w-full rounded" alt="Sacred Heart Convent School, Jagraon" /></SlideshowLightbox>
                        </div><div className="eventboxdesc">
                            <div className="eventpgh">
                            <h5>Events Title</h5>
                            <p>Stay Tunned For More Updates Stay Tunned For More Updates Stay Tunned For More Updates</p>
                            </div>
                        <div className="eventdate">
                            <span><i className="bi bi-alarm"></i> 00:00</span>
                            <span><i className="bi bi-calendar"></i> 28.02.2024</span>
                            <span><i className="bi bi-geo-alt"></i> School campus</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 eventCount " data-month="1">
                    <div className="eventbox">
                        <div className="eventboximg">
                        <div className="eventattch"><Link to=" " target="_blank"><i className="bi bi-paperclip"></i></Link></div> 
                         <SlideshowLightbox><img src={events} className="img-fluid border-img w-full rounded" alt="Sacred Heart Convent School, Jagraon" /></SlideshowLightbox>
                        </div><div className="eventboxdesc">
                            <div className="eventpgh">
                            <h5>Events Title</h5>
                            <p>Stay Tunned For More Updates Stay Tunned For More Updates Stay Tunned For More Updates</p>
                            </div>
                            <div className="eventdate">
                            <span><i className="bi bi-alarm"></i> 00:00</span>
                            <span><i className="bi bi-calendar"></i> 28.02.2024</span>
                            <span><i className="bi bi-geo-alt"></i> School campus</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 eventCount " data-month="2">
        <div className="eventbox">
                        <div className="eventboximg">
                        <div className="eventattch"><Link to=" " target="_blank"><i className="bi bi-paperclip"></i></Link></div> 
                         <SlideshowLightbox><img src={events} className="img-fluid border-img w-full rounded" alt="Sacred Heart Convent School, Jagraon" /></SlideshowLightbox>
                        </div><div className="eventboxdesc">
                            <div className="eventpgh">
                            <h5>Events Title</h5>
                            <p>Stay Tunned For More Updates Stay Tunned For More Updates Stay Tunned For More Updates</p>
                            </div>
                            <div className="eventdate">
                            <span><i className="bi bi-alarm"></i> 00:00</span>
                            <span><i className="bi bi-calendar"></i> 28.02.2024</span>
                            <span><i className="bi bi-geo-alt"></i> School campus</span>
                            </div>
                        </div>
                    </div>
        </div>

                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 eventCount " data-month="2">
                    <div className="eventbox">
                        <div className="eventboximg">
                        <div className="eventattch"><Link to=" " target="_blank"><i className="bi bi-paperclip"></i></Link></div> 
                         <SlideshowLightbox><img src={events} className="img-fluid border-img w-full rounded" alt="Sacred Heart Convent School, Jagraon" /></SlideshowLightbox>
                        </div><div className="eventboxdesc">
                            <div className="eventpgh">
                            <h5>Events Title</h5>
                            <p>Stay Tunned For More Updates Stay Tunned For More Updates Stay Tunned For More Updates</p>
                            </div>
                            <div className="eventdate">
                            <span><i className="bi bi-alarm"></i> 00:00</span>
                            <span><i className="bi bi-calendar"></i> 28.02.2024</span>
                            <span><i className="bi bi-geo-alt"></i> School campus</span>
                            </div>
                        </div>
                    </div>
                </div>
                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 eventCount " data-month="2">
                    <div className="eventbox">
                        <div className="eventboximg">
                        <div className="eventattch"><Link to=" " target="_blank"><i className="bi bi-paperclip"></i></Link></div> 
                         <SlideshowLightbox><img src={events} className="img-fluid border-img w-full rounded" alt="Sacred Heart Convent School, Jagraon" /></SlideshowLightbox>
                        </div><div className="eventboxdesc">
                            <div className="eventpgh">
                            <h5>Events Title</h5>
                            <p>Stay Tunned For More Updates Stay Tunned For More Updates Stay Tunned For More Updates</p>
                            </div>
                            <div className="eventdate">
                            <span><i className="bi bi-alarm"></i> 00:00</span>
                            <span><i className="bi bi-calendar"></i> 28.02.2024</span>
                            <span><i className="bi bi-geo-alt"></i> School campus</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 eventCount " data-month="2">

            <div className="eventbox">
                        <div className="eventboximg">
                        <div className="eventattch"><Link to=" " target="_blank"><i className="bi bi-paperclip"></i></Link></div> 
                         <SlideshowLightbox><img src={events} className="img-fluid border-img w-full rounded" alt="Sacred Heart Convent School, Jagraon" /></SlideshowLightbox>
                        </div><div className="eventboxdesc">
                            <div className="eventpgh">
                            <h5>Events Title</h5>
                            <p>Stay Tunned For More Updates Stay Tunned For More Updates Stay Tunned For More Updates</p>
                            </div>
                            <div className="eventdate">
                            <span><i className="bi bi-alarm"></i> 00:00</span>
                            <span><i className="bi bi-calendar"></i> 28.02.2024</span>
                            <span><i className="bi bi-geo-alt"></i> School campus</span>
                            </div>
                        </div>
                    </div>
        </div>
                <div className="load-more">
                    <div className="next">Show More</div>
                </div>
            </div>
            

        </div>
        </div>
     </>
  )
}

export default Events
